'use client';

import { useSyncExternalStore } from 'react';
import {
  isSupportLandingPending,
  subscribeToSupportLanding,
} from '../utils/supportLanding';

/**
 * `true` while an admin support-scope landing is still establishing its session
 * in this tab (see `../utils/supportLanding`).
 *
 * Consumers use it to HOLD — never to grant. Holding renders a loading state
 * and nothing else, so it can only ever delay UI, not expose it.
 *
 * `useSyncExternalStore` rather than a `useState`+effect pair: the phase is
 * module state that is read during render by more than one component, and a
 * subscribe-in-effect would let a component commit a render based on a phase
 * that had already changed.
 */
export const useSupportLandingPending = (): boolean =>
  useSyncExternalStore(
    subscribeToSupportLanding,
    isSupportLandingPending,
    // Server snapshot: SSR has no landing of its own, and the subtree that
    // consumes this is client-only anyway (SelectionProvider gates children on
    // hydration). Reporting `false` keeps the server render identical to the
    // pre-landing client render.
    () => false,
  );
